import React, { useState, useEffect } from "react";
import {
  Button,
  Flex,
  Box,
  FormControl,
  FormErrorMessage,
  Image,
  Input,
  Text,
  useToast,
  InputGroup,
  Link,
  InputRightElement,
  useColorMode,
} from "@chakra-ui/react";
import { Icon, SearchIcon } from "@chakra-ui/icons";
import { MdMail } from "react-icons/md";
import {
  FaLinkedin,
  FaTwitter,
  FaYoutube,
  FaFacebook,
  FaLink,
  FaBookmark,
  FaEdit,
} from "react-icons/fa";
import { useForm } from "react-hook-form";
import { validateEmail } from "@/src/utils/validate-functions";
import useTranslation from "next-translate/useTranslation";
import { pricing, subscribe } from "@/services/contact";

export default function BlogSubscription(props){
    const { t } = useTranslation();
    const toast = useToast();
    const [loading,setLoading] = React.useState(false);
    const {
      handleSubmit,
      register,
      formState: { errors, isSubmitting }} = useForm({ mode: "all" });
      
      const { colorMode } = useColorMode();
    
      async function onSubmit(data) {
        setLoading(true);
        const resp = await subscribe(data);
        if (resp?.subscribe) {
          setLoading(false);
          toast({
            position: "top-right",
            title: t("dashboard:notification.success"),
            description: resp?.subscribe?.detail,
            status: "success",
            duration: 8000,
            isClosable: true,
          });
        } else {
          setLoading(false);
          toast({
            position: "top-right",
            title: t("dashboard:notification.error"),
            description: t("dashboard:notification.error_desc"),
            status: "error",
            duration: 8000,
            isClosable: true,
          });
          setLoading(false);
        }
      }
    return (<Box
    as="form"
    onSubmit={handleSubmit((data) => onSubmit(data))}
        mt="52px"
        p="25px"
        position="relative"
        bgColor={"#00B295"}
        borderRadius={"8px"}
        w={{ base: "100%", lg: "300px" }}
        minH="322px"
        {...props}
      >
        <Image
          alt={"dot-top"}
          src={"/images/ellipse_blog.svg"}
          left={"0"}
          position={"absolute"}
          top={"0"}
        />
        <Image
          alt={"dot-top"}
          src={"/images/paper_blog.svg"}
          left={"50"}
          transform="rotate(-10deg)"
          position={"absolute"}
          top={"28px"}
        />

        {/* /images/paper_blog.svg */}
        <Text color="#fff" mt="90px" fontWeight="600" fontSize="24px">
          {t("blog:listining_card.title")}
        </Text>
        <Text color="#fff" fontWeight="500" fontSize="12px">
          {t("blog:listining_card.description")}
        </Text>
        <InputGroup mt={5} transform={"auto"}>
          <FormControl isInvalid={errors.email}>
            <Input
              borderRadius={"4"}
              w={"full"}
              placeholder={t("blog:listining_card.input_placeholder")}
              borderColor={colorMode === "light" ? "inherit" : "brand.700"}
                  bg={colorMode === "light" ? "white" : "transparent"}
                  _placeholder={{
                    color: colorMode === "light" ? "inherit" : "gray.200",
                  }}
              id="email"
              name={"email"}
              type={"email"}
              pr="80px"
              {...register("email", {
                required: t("blog:listining_card.input_required"),
              })}
            />
            <FormErrorMessage>
              {errors.email && errors.email.message}
            </FormErrorMessage>
          </FormControl>
          <InputRightElement w={"68px"} mt={1} mr={0}>
            <Button
              borderRadius={"4px"}
              color="#fff"
              h="full"
              fontSize="12px"
              fontWeight="500"
              w={"full"}
              type={"submit"}
              colorScheme={"brand"}
            >
              {t("blog:listining_card.button_text")}
            </Button>
          </InputRightElement>
        </InputGroup>

        <Image
          alt={"dot-top"}
          src={"/images/ellipse-4_blog.svg"}
          right={"0"}
          position={"absolute"}
          bottom={"0"}
        />
        <Image
          alt={"dot-top"}
          src={"/images/paper-airplane_blog.svg"}
          right={"50px"}
          transform="rotate(0deg)"
          position={"absolute"}
          bootom={"28px"}
        />
      </Box>)
}